export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14478.85754381.jpg";